<template>
  <div>{{ t('settings.mcpServers.test.title') }}</div>
  <div v-if="result">
    <div>
      {{ result.success ? t('settings.mcpServers.test.successful') : t('settings.mcpServers.test.error') }}
    </div>
    <div v-if="result.message">
      {{ JSON.stringify(result.message) }}
    </div>
  </div>

  <div>
    <Button @click="runTest">{{ t('settings.mcpServers.test.button') }}</Button>
  </div>
</template>

<script setup lang="ts">
import type {
  ApiMcpServerTestResponse,
  ApiMcpServer
} from "~/server/api/organizations/[organizationId]/mcpServers/types";

const { t } = useI18n();

const props = defineProps<{
  mcpServer: ApiMcpServer;
}>();

const result = ref<ApiMcpServerTestResponse | null>(null);

const { organizationId } = useOrganizationId();

async function runTest() {
  result.value = null;
  try {
    const response = await $fetch<ApiMcpServerTestResponse>(
      `/api/organizations/${organizationId.value}/mcpServers/${props.mcpServer.id}/test`,
      {
        method: "POST"
      }
    );
    result.value = response;
  } catch (error) {
    result.value = {
      success: false,
      message: error as string
    };
  }
}
</script>
